import { Button, Dialog } from '@radix-ui/themes';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

function ConfirmationModal({
  message,
  onHide,
  show,
  onConfirm,
  confirmButtonText,
}: {
  message: (string | ReactNode)[];
  onHide: () => void;
  show: boolean;
  onConfirm: () => void;
  confirmButtonText?: string;
}) {
  const { t } = useTranslation();
  const effectiveConfirmButtonText = confirmButtonText ?? t('confirmModal.confirmButton');

  return (
    <Dialog.Root open={show} onOpenChange={() => onHide()}>
      <Dialog.Content>
        <Dialog.Title>{t('confirmModal.title')}</Dialog.Title>
        <Dialog.Description>{message}</Dialog.Description>

        <div className="flex w-full">
          <div className="w-1/2 px-4">
            <Dialog.Close>
              <Button size="3" color="gray" variant="soft" className="w-full">
                {t('confirmModal.cancelButton')}
              </Button>
            </Dialog.Close>
          </div>
          <div className="w-1/2 px-4">
            <Dialog.Close>
              <Button size="3" color="red" className="w-full" onClick={onConfirm}>
                {effectiveConfirmButtonText}
              </Button>
            </Dialog.Close>
          </div>
        </div>
      </Dialog.Content>
    </Dialog.Root>
  );
}

export default ConfirmationModal;
